import React, { useRef, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import SplashScreen from "./SplashScreen";
// import * as auth from "./authRedux";
import { setUserCapabilities, setCurrentCapabilities, setSuperAdmin, setUserDetails } from "./redux/slices/authSlice";
import { setCategories, setLanguages } from "./redux/slices/dashboardSlice";
import { initializeUserData } from "./LoginInit";
import { isEmpty } from "../helpers/Functions";
import { getCategories } from "./crud/category.crud";
import displayToast from "../theme/partials/DisplayToast";

const AuthInit = ({
	setUserCapabilities,
	setCurrentCapabilities,
	currentCapabilities,
	isSuperAdmin,
	setSuperAdmin,
	setCategories,
	authToken,
	setLanguages,
	setUserDetails,
	...props
}) => {
	const [showSplashScreen, setShowSplashScreen] = useState(true);

	// We should request user by authToken before rendering the application
	useEffect(() => {
		if (!authToken) {
			setShowSplashScreen(false);
			return;
		}

		let didCancel = false;

		const init = async () => {
			try {
				if (!didCancel) {
					await initializeUserData(
						setUserCapabilities,
						setCurrentCapabilities,
						setSuperAdmin,
						currentCapabilities,
						setLanguages,
						undefined,
						false,
						setUserDetails
					);
				}
			} catch (error) {
				if (!didCancel) {
					// todo: dispatch(props.logout()); ???
				}
			} finally {
				if (!didCancel) setShowSplashScreen(false);
			}
		};

		init();

		return () => {
			didCancel = true;
		};
	}, []);

	useEffect(() => {
		if (!isEmpty(currentCapabilities?.company?.company_id)) {
			getCategories(currentCapabilities.company.company_id).then((response) => {
				if (response.data.init[0].status === "error") {
					displayToast("error", response.data.init[0]["message"]);
				} else {
					if (response.data.init[0].recno == 0) {
						setCategories([]);
					} else {
						setCategories(response.data.data);
					}
				}
			});
		}
	}, [currentCapabilities?.company?.company_id]);

	return showSplashScreen ? <SplashScreen /> : <>{props.children}</>;
};

const mapStateToProps = (state) => {
	let data = {
		currentCapabilities: state.auth.current_capabilities,
		isSuperAdmin: state.auth.is_super_admin,
		authToken: state.auth.token,
	};

	return data;
};

const mapDispatchToProps = {
	setUserCapabilities,
	setCurrentCapabilities,
	setSuperAdmin,
	setCategories,
	setLanguages,
	setUserDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthInit);
